module.exports = __webpack_public_path__ + "img/login_text_btm.88a41bd5.png";